import { useTheme } from "@emotion/react";
import Chip from "@mui/material/Chip";

export default function StatusChip({ status }) {
  const theme = useTheme();
  const statusConfig = {
    pending: {
      bgcolor: theme.palette.brain.yellow.background,
      color: theme.palette.brain.yellow.text,
      border: theme.palette.brain.yellow.border,
    },
    "re-submitted": {
      bgcolor: theme.palette.brain.yellow.background,
      color: theme.palette.brain.yellow.text,
      border: theme.palette.brain.yellow.border,
    },
    approved: {
      bgcolor: theme.palette.brain.green.background,
      color: theme.palette.brain.green.text,
      border: theme.palette.brain.green.border,
    },
    returned_for_review: {
      bgcolor: theme.palette.brain.red.background,
      color: theme.palette.brain.red.text,
      border: theme.palette.brain.red.border,
    },
    rejected: {
      bgcolor: theme.palette.brain.red.background,
      color: theme.palette.brain.red.text,
      border: theme.palette.brain.red.border,
    },
    submitted: {
      bgcolor: theme.palette.brain.blue.background,
      color: theme.palette.brain.blue.text,
      border: theme.palette.brain.blue.border,
    },
    drafted: {
      bgcolor: theme.palette.brain.yellow.background,
      color: theme.palette.brain.yellow.text,
      border: theme.palette.brain.yellow.border,
    },
  };
  const s = statusConfig[status] || statusConfig.pending;
  return (
    <Chip
      label={status}
      size="small"
      variant="outlined"
      sx={{
        bgcolor: s.bgcolor,
        color: s.color,
        borderColor: s.border,
        textTransform: "capitalize",
        fontWeight: 550,
        fontSize: "0.75rem",
      }}
    />
  );
}
